import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { useAuthDataContext } from "./AuthDataProvider";
import Cookies from 'js-cookie';
import {jwtDecode} from 'jwt-decode';
import Unauthorized from './pages/401.tsx';

const PrivateRoute = (routeProps) => {
  let navigate = useNavigate();
  let { user } = useAuthDataContext();
  const [isRefreshing, setIsRefreshing] = useState(false);

  useEffect(() => {
    if (user === null) {
      const token = Cookies.get("__session") ? Cookies.get("__session") : null;
      if (token) {
        user = jwtDecode(token);
      }
    }

    if (user) {
      const now = Math.floor(Date.now() / 1000);

      // If access token expired, try to use refresh token to get new access token
      if (now > user.expiration) {
        console.log("Token Expired, trying to refresh");
        setIsRefreshing(true);
      }
    } else {
      navigate("/login");
    }
  }, [user, navigate]);

  const userHasRequiredRole = () => {
    if (routeProps.requiredRoles === undefined) {
      return true;
    }
    return routeProps.requiredRoles?.some((r) => user?.roles.includes(r));
  };

  useEffect(() => {
    if (isRefreshing) {
      navigate(`/refresh?redirect=${window.location.pathname}`);
    }
  }, [isRefreshing, navigate]);

  if (isRefreshing) {
    return null; // Avoid rendering anything while redirecting
  }

  if (user) {
    return userHasRequiredRole() ? (
      <Outlet {...routeProps} />
    ) : (
      <Unauthorized />
    );
  }

  return null;
};

export default PrivateRoute;